import React from "react";

type Props = {
  menuButton: React.ReactNode;
  sideMenu: React.ReactNode;
  topBar: React.ReactNode;
  children: React.ReactNode;
};

/**
 * Baslayout för appens shell (meny + container + topbar).
 * Förbereder för router genom att kapsla strukturen i en egen komponent.
 */
export function AppShellLayout({ menuButton, sideMenu, topBar, children }: Props): JSX.Element {
  return (
    <div className="gw-shell">
      {sideMenu}
      <div className="gw-container w-full px-2 sm:px-4 md:px-6">
        <div className="mb-3 flex w-full justify-end">{topBar}</div>
        <div className="w-full">{children}</div>
      </div>
    </div>
  );
}
